import React, { useState } from "react";
import { login, translateAuthError } from "../api/authApi";
import AuthBrandPanel from "./AuthBrandPanel";

// Wraps every /admin/* page. There's no public account system anymore —
// this is the only login gate the site has, so instead of redirecting to a
// separate /login page (which no longer exists), it renders an inline
// admin sign-in form right at /admin itself, and only then shows the
// wrapped page.
function AdminRoute({ children }) {
  const [session, setSession] = useState({
    token: localStorage.getItem("token"),
    role: localStorage.getItem("role"),
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (session.token && session.role === "admin") {
    return children;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const { token, role } = await login(username, password);
      if (role !== "admin") {
        setError("این حساب به پنل مدیریت دسترسی ندارد.");
        return;
      }
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      setSession({ token, role });
    } catch (err) {
      setError(translateAuthError(err.message));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-shell">
      <AuthBrandPanel
        eyebrow="مجلهٔ دریچه"
        heading="پنل مدیریت"
        tagline="برای ساخت و ویرایش محتوای مجله، با حساب مدیریت وارد شوید."
      />

      <div className="auth-form-panel">
        <form className="auth-card" onSubmit={handleSubmit}>
          <span className="corner corner-tr" />
          <span className="corner corner-tl" />
          <span className="corner corner-br" />
          <span className="corner corner-bl" />

          <h2>ورود مدیر</h2>
          <p className="auth-subtitle">این بخش تنها برای مدیران مجله در دسترس است.</p>

          {error && <p className="error">{error}</p>}

          <div className="auth-field">
            <label htmlFor="admin-username">نام کاربری</label>
            <input
              id="admin-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="admin-password">رمز عبور</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="auth-submit" disabled={submitting}>
            {submitting ? "در حال ورود..." : "ورود"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminRoute;
